import { store } from './index'
import { defineStore } from 'pinia'

import { useCache } from '@/hooks/useCache'

interface AppState {
    CurrencyList: Array<SelectItem>
}

const { wsCache } = useCache()

export const useCurrencyStore = defineStore('CtCurrency', {
    state: (): AppState => {
        return {
            CurrencyList: [
                { name: "澳元", value: "AUD" },
                { name: "瑞士法郎", value: "CHF" },
                { name: "欧元", value: "EUR" },
                { name: "英镑", value: "GBP" },
                { name: "港币", value: "HKD" },
                { name: "日币", value: "JPY" },
                { name: "马来西亚币", value: "MYR" },
                { name: "波兰币", value: "PL" },
                { name: "人民币", value: "RMB" },
                { name: "瑞典克朗", value: "SEK" },
                { name: "泰铢", value: "THB" },
                { name: "新台币", value: "TWD" },
                { name: "美元", value: "USD" },
                { name: "越南盾", value: "VND" },
            ]
        }
    },
    getters: {
        getList(): Array<SelectItem> {
            return this.CurrencyList
        },
    },
    actions: {
        // categorys: Array<SelectItem> | any
        setCurrencyList() {
            this.CurrencyList = [];
        }
    },
})

export const useAppStoreWithOut = () => {
    return useCurrencyStore(store)
}